import { useNavigate } from 'react-router-dom';

const ConnectionWarning = () => {
    const navigate = useNavigate();

    return (
        <div style={{
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 'clamp(var(--spacing-md), 3vw, var(--spacing-lg))',
            overflow: 'auto'
        }}>
            <div style={{
                width: '100%',
                maxWidth: '450px',
                textAlign: 'center'
            }}>
                {/* Icon */}
                <div style={{
                    width: 'clamp(50px, 12vw, 64px)',
                    height: 'clamp(50px, 12vw, 64px)',
                    margin: '0 auto var(--spacing-sm)',
                    backgroundColor: 'var(--color-warning-100)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0
                }}>
                    <svg width="clamp(24px, 6vw, 32px)" height="clamp(24px, 6vw, 32px)" viewBox="0 0 24 24" fill="none" stroke="var(--color-warning-600)" strokeWidth="2">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                    </svg>
                </div>

                {/* Title */}
                <h3 style={{
                    fontSize: 'clamp(0.9375rem, 2.5vw, 1.125rem)',
                    fontWeight: '600',
                    color: 'var(--color-text-primary)',
                    margin: '0 0 var(--spacing-xs) 0',
                    lineHeight: '1.3'
                }}>
                    Provider Not Connected
                </h3>

                {/* Description */}
                <p style={{
                    fontSize: 'clamp(0.75rem, 2vw, 0.8125rem)',
                    color: 'var(--color-text-secondary)',
                    margin: '0 0 var(--spacing-sm) 0',
                    lineHeight: '1.5'
                }}>
                    Connect to a data feed provider to access market data and charts.
                </p>

                {/* Action button */}
                <button
                    onClick={() => navigate('/account')}
                    style={{
                        width: '100%',
                        padding: 'clamp(var(--spacing-xs), 2vw, var(--spacing-sm)) var(--spacing-md)',
                        backgroundColor: 'var(--color-primary-600)',
                        border: 'none',
                        borderRadius: 'var(--radius-md)',
                        color: 'white',
                        fontSize: 'clamp(0.75rem, 2vw, 0.875rem)',
                        fontWeight: '600',
                        cursor: 'pointer',
                        transition: 'all 200ms ease-in-out',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 'var(--spacing-xs)',
                        marginBottom: 'var(--spacing-sm)'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = 'var(--color-primary-700)';
                        e.currentTarget.style.transform = 'translateY(-1px)';
                        e.currentTarget.style.boxShadow = 'var(--shadow-md)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = 'var(--color-primary-600)';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                    }}
                >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                    <span>Account Settings</span>
                </button>

                {/* Features list */}
                <div style={{
                    backgroundColor: 'var(--color-gray-50)',
                    borderRadius: 'var(--radius-md)',
                    padding: 'var(--spacing-sm)',
                    textAlign: 'left'
                }}>
                    <p style={{
                        fontSize: 'clamp(0.6875rem, 1.8vw, 0.75rem)',
                        fontWeight: '600',
                        color: 'var(--color-text-primary)',
                        margin: '0 0 4px 0'
                    }}>
                        Once connected:
                    </p>
                    <ul style={{
                        margin: 0,
                        paddingLeft: 'var(--spacing-md)',
                        fontSize: 'clamp(0.6875rem, 1.8vw, 0.75rem)',
                        color: 'var(--color-text-secondary)',
                        lineHeight: '1.6'
                    }}>
                        <li>Search and add instruments</li>
                        <li>View real-time price updates</li>
                        <li>Access interactive charts</li>
                        <li>Analyze with technical indicators</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ConnectionWarning;
